export const defaultValues = {
  PROPERTY_VALUE: 250000,
  MONTHLY_RENT: 1000,
  INSTANT_RESULT: false,
  CURRENCY: "£",
  PRICE_PREFIX: true
}
